<template>
    <div>
        <van-tabs v-model="active" swipeable sticky animated color="#066BEE" line-height="2px"
                  @change="getProductListData()">
            <van-tab v-for="item in list" :key="item.type" :title="item.title">
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 15px; margin-bottom: 10px; background:linear-gradient(270deg,rgba(64,182,248,1) 0%,rgba(69,135,221,1) 100%);">
                    <div style="display: flex; align-items: center;">
                        <van-image v-if="item.info.ranking && item.info.ranking <= 2" :src="require(`@/assets/rank${item.info.ranking}.png`)" round width="24" height="30"/>
                        <div v-else style="color: white; font-size: 14px; width: 24px; text-align: center;">{{item.info.ranking || '--'}}</div>
                        <van-image :src="item.info.imageUrl ? item.info.imageUrl : user.imageUrl" round width="50" height="50" style="margin: 0 10px 0 23px"/>
                        <div style="color: white; font-size: 14px;">{{item.info.userName || user.userName}}</div>
                    </div>
                    <div style="color: white; font: 20px bold;">{{item.info.score || '0'}}</div>
                </div>
                <van-list v-model="item.loading" :finished="item.finished" finished-text="没有更多了" @load="getProductListData">
                    <div v-for="(subItem, index) in item.list" :key="index"
                         style="display: flex; justify-content: space-between; align-items: center; padding: 15px; background-color: white;">
                        <div style="display: flex; align-items: center;">
                            <van-image v-if="index <= 2" :src="require(`@/assets/rank${index+1}.png`)" round width="24" height="30"/>
                            <div v-else style="color: #1D8FE1; font-size: 14px; width: 24px; text-align: center;">{{index+1}}</div>
                            <van-image :src="subItem.imageUrl ? subItem.imageUrl : require('@/assets/defaultProfile.jpg')" round width="50" height="50" style="margin: 0 10px 0 23px"/>
                            <div style="color: #333333; font-size: 14px;">{{subItem.userName}}</div>
                        </div>
                        <div style="color: #999999; font: 20px bold;">{{subItem.score}}</div>
                    </div>
                </van-list>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Tab, Tabs, List, Cell, Image} from 'vant';
    import Cookies from 'js-cookie'
    import {wxChatShare} from '@/utils/wxShare'
    Vue.use(Tab).use(Tabs).use(List).use(Cell).use(Image);

    export default {
        name: "Rank",
        data() {
            return {
                infoUrl: this.$route.query.integral ? 'integral/own' : '/love/loveNum',
                rankUrl: this.$route.query.integral ? 'integral/ranking' : '/love/ranking',
                type: Cookies.get('type'),
                user: this.$store.state.user.user,
                active: 0,
                pageSize: 10,
                list: [{title: '日榜', type: 1, page: 0, list: [],loading: false, finished: false, info:{}},
                    {title: '月榜', type: 3, page: 0, list: [],loading: false, finished: false, info:{}},
                    {title: '总榜', type: 0, page: 0, list: [],loading: false, finished: false, info:{}}],
                me: {}
            }
        },
        mounted(){
            if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.goBack, false);
            }
        },
        destroyed(){
            window.removeEventListener('popstate', this.goBack, false);
        },
        methods: {
            goBack(){
                this.$router.replace({path: '/'});
            },
            settingShare() {
                let number = this.list[this.active].info.score || '0'
                let rank = this.list[this.active].info.ranking || '0'
                let name = this.active === 0 ? '日榜' : this.active === 1 ? '月榜' : '总榜'
                let title = this.type === '0' ? '益宝' : '心智宝'
                let param = {
                    url: window.location.href.split('#')[0], // 当前页面url
                    title: '我获得了' + Number(number) + '颗爱心，在' + title + name + '排第' + rank + '名', // 分享数据配置 主标题
                    desc: '你也来看看自己的爱心值排名吧！', // 分享数据配置 副标题
                    link: process.env.VUE_APP_SHARE_URL + '/rank?shareId=' + this.user.userId + '&type=' + this.type, // 分享数据配置
                    imgUrl: 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191017/897150e018d483eaf6a41be0d0b5db00.png', // 分享数据配置 －－ 全路径
                    type: "link", // 分享类型,music、video或link，不填默认为link
                    dataUrl: " ", // 如果type是music或video，则要提供数据链接，默认为空
                }
                console.log(param)
                wxChatShare(param);
            },
            getProductListData() {
                this.$axios.get(this.infoUrl,{params: {type: this.list[this.active].type}}).then(res => {
                    this.list[this.active].info = res.data
                    this.settingShare()
                }).catch(err => {
                    console.log(err);
                })

                const item = this.list[this.active]
                if (item.finished) {
                    return
                }
                item.page++;
                item.loading = true;
                let params = {
                    type: item.type,
                    page: item.page,
                    pageSize: this.pageSize
                };
                this.$axios.get(this.rankUrl, {params: params}).then(res => {
                    item.loading = false;
                    let data = res.data.rows;
                    item.list = item.list.concat(data);
                    if (data.length < this.pageSize) {
                        item.finished = true;
                    }
                }).catch(err => {
                    console.log(err);
                    item.loading = false
                })
            }
        }
    }
</script>

<style scoped>

</style>
